import { CustomBottomBar } from '@components';
import { Button, Container, Input, Typography } from '@design-system';
import { getCompanyChoice } from '@features/company/company.slice';
import React from 'react';
import { useSelector } from 'react-redux';
import './LoginPage.scss';
import { useLoginPageVM } from './useLoginPageVM';
import logoEcs from '@assets/images/logo/ecs-logo.png';
import logoEcsOccitanie from '@assets/images/logo/ecs-occitanie-logo.png';

export const LoginPage: React.FC = () => {
    const { mail, password, setMail, setPassword, handleSubmit, isLoading, isSubmitable } = useLoginPageVM();
    const companyChoice = useSelector(getCompanyChoice) || null;

    const getCompanyLogo = () => {
        switch (companyChoice) {
            case 'ecs':
                return logoEcs;
            case 'ecs-occitanie':
                return logoEcsOccitanie;
            default:
                return logoEcs;
        }
    };

    return (
        <Container className="login-page" padding="none">
            <Container>
                <Container padding="medium-large-spacing large-spacing">
                    {companyChoice && (
                        <div className="company-info">
                            <div className="company-logo-container">
                                <img src={getCompanyLogo()} alt={`Logo ${companyChoice}`} className="company-logo" />
                            </div>
                        </div>
                    )}

                    <form className="login-form" onSubmit={(e) => handleSubmit(e)}>
                        <Input label="Email" placeholder="Email" value={mail} onValueChange={setMail} type="email" />
                        <Input
                            label="Mot de passe"
                            placeholder="Mot de passe"
                            value={password}
                            onValueChange={setPassword}
                            isPassword={true}
                        />
                        <CustomBottomBar>
                            <Button
                                color="marine"
                                size="fullwidth"
                                onClick={handleSubmit}
                                disabled={!isSubmitable || isLoading}
                                type="submit"
                            >
                                <Typography intrinsic="h4">Connexion</Typography>
                            </Button>
                        </CustomBottomBar>
                    </form>
                </Container>
            </Container>
        </Container>
    );
};
